/**************************************************
 * Nombre:       Detalle_Galeria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import 'photoswipe/dist/photoswipe.css'
import {Gallery, Item} from "react-photoswipe-gallery";
import {useEffect, useState} from "react";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Detalle_Galeria = ({item}) => {
    const {sCell, sTab} = useResponsive()
    const [imagenes, setImagenes] = useState([])


    useEffect(() => {

        setImagenes([])

        if (item && item.imgs) {
            for (let i = 0; i < item.imgs.length; i++) {
                let foto = new Image();
                foto.src = item.imgs[i];
                //etner cuidado por que se asigna a una imagen que ya esta en la pagina
                document.images[2].src = foto.src;
                let ima = document.images[2]
                ima.addEventListener('load', () => {

                    let ancho = foto.width;
                    let alto = foto.height;


                    let obj = {
                        url: item.imgs[i],
                        alto: alto,
                        ancho: ancho
                    }

                    setImagenes((arr) => arr.concat(obj))
                })


            }

            // document.images[1].src = logo
        }


    }, [item]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: 32,
                                        fontWeight: 800
                                    }}>Galeria de Fotos</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        fontSize: 16,
                                        fontWeight: 300
                                    }}>
                                        Explora nuestra galería y déjate llevar por una primera mirada a la experiencia
                                        única
                                        que
                                        vivirás en cada tour. Cada imagen refleja la emoción, belleza y magia de lo que
                                        te
                                        espera.
                                    </Typography>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Gallery id={'gal'}>
                                <Splide
                                    aria-label="My Favorite Images" style={{width: '100%', alignItems: 'center'}}
                                    options={{
                                        autoplay: true,
                                        speed: 1500,
                                        rewind: true,
                                        perPage: sCell ? 2 : sTab ? 3 : 4,
                                        arrows: false,
                                        pagination: false,
                                        width: '100%',
                                        drag: 'free',
                                        interval: 5000,
                                        noDrag: true,
                                        gap: 40
                                    }}
                                >

                                    <SplideSlide
                                        key={`qe`}
                                        style={{alignItems: 'center'}}>
                                        <Grid
                                            item container lg={12} sm={12} xs={12} sx={{
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                            height: sCell ? 250 : 500

                                        }}>

                                            <Grid item container lg={12} sm={12} xs={12} sx={{
                                                justifyContent: 'flex-start',
                                                border: 8,
                                                borderColor: '#fff',
                                                boxShadow: 4,

                                            }}>
                                                <Item
                                                    original={''}
                                                    thumbnail={''}
                                                    width={''}
                                                    height={''}
                                                >
                                                    {({ref, open}) => (
                                                        <img
                                                            key={`sad${4}`}
                                                            ref={ref}
                                                            onClick={open}
                                                            src={''} width={'100%'} height={'auto'}/>

                                                    )}
                                                </Item>
                                            </Grid>


                                        </Grid>


                                    </SplideSlide>


                                    {imagenes.map((item, index) => {


                                        return (
                                            <SplideSlide
                                                key={`qe${index}`}
                                                style={{alignItems: 'center'}}>
                                                <Grid
                                                    item container lg={12} sm={12} xs={12} sx={{
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    height: sCell ? 250 : 500

                                                }}>

                                                    <Grid item container lg={12} sm={12} xs={12} sx={{
                                                        justifyContent: 'flex-start',
                                                        border: 8,
                                                        borderColor: '#fff',
                                                        boxShadow: 4,

                                                    }}>
                                                        <Item
                                                            original={item.url}
                                                            thumbnail={item.url}
                                                            width={item.ancho}
                                                            height={item.alto}
                                                        >
                                                            {({ref, open}) => (
                                                                <img
                                                                    key={`ad${index}`}
                                                                    ref={ref}
                                                                    onClick={open}
                                                                    src={item.url} width={'100%'} height={'auto'}/>

                                                            )}
                                                        </Item>
                                                    </Grid>


                                                </Grid>


                                            </SplideSlide>
                                        )
                                    })}


                                </Splide>
                            </Gallery>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Detalle_Galeria